// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"8dbf35c7","444":"54cd84c1","635":"00e0195b"}[chunkId] + ".chunk.js";
};